import { use } from 'react';

import styled from '@emotion/styled';
import { useTranslations } from 'use-intl';

import { SurveyThemeContext } from '@/shared-utilities';

const ThemedRoot = styled.div<{ themeStyles: Record<string, string> }>`
  ${(props) => props.themeStyles}
`;

const ProjectUsabilityResponseUnsupportedBrowser = () => {
  const { styles } = use(SurveyThemeContext);
  const t = useTranslations('Usability');

  return (
    <ThemedRoot
      themeStyles={styles}
      data-test='usability-unsupported-browser'
      className='flex min-h-dvh items-center justify-center bg-(image:--brand-bg-image) bg-cover bg-center bg-no-repeat p-6'
    >
      <output
        aria-live='polite'
        className='block w-full max-w-md rounded-2xl border border-gray-200 bg-white p-8 text-center shadow-lg'
      >
        <h2 className='mb-4 text-xl font-semibold text-gray-900'>
          {t('unsupportedBrowserTitle')}
        </h2>
        <p className='text-left leading-relaxed text-gray-600'>
          {t('unsupportedBrowserMessage')}
        </p>
      </output>
    </ThemedRoot>
  );
};

export default ProjectUsabilityResponseUnsupportedBrowser;
